<template>
	<el-dialog title="填写执行考核信息" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
		:visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="600px" height="80%"
		@close="dialogClose" v-el-drag-dialog v-el-dialog-center>
		<template>
			<div id="containt">
				<div style="padding: 5px 8px;">

					<div class="append">
						<span class="item2">考核金额:</span>
						<el-input placeholder="请输入内容" v-model="input" :disabled="true" style="width: 110px;">
						</el-input>
					</div>
					<div class="append">
						<span class="item2">调整金额:</span>
						<el-input placeholder="请输入内容" v-model="input2" style="width: 110px;">
						</el-input>
					</div>
					<div class="append">
						<span class="item2">总金额:</span>
						<el-input placeholder="请输入内容" v-model="input3" :disabled="true" style="width: 110px;">
						</el-input>
					</div>
					<div class="append">
						<span class="item2">最后审批金额:</span>
						<el-input placeholder="请输入内容" v-model="input4" :disabled="true" style="width: 110px;">
						</el-input>
					</div>
					<div class="append">
						<span class="item1">申诉内容:</span>
						<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容"
							v-model="textarea2" style="width: 400px;">
						</el-input>
					</div>
					<div class="append">
						<span class="item1">审批意见:</span>
						<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容"
							v-model="textarea3" style="width: 400px;">
						</el-input>
					</div>
					<div class="append">
						<div class="append">
							<span class="item1">凭证1:</span>
							<div    >
								<el-upload style="display:flex" :class="{ hide_box4: upload_btn4 }" :disabled="true"
									action="/admin/sys-file/upload" :on-remove="handleRemove4" list-type="picture-card"
									:file-list="formData.businessPhoto" :on-change="handleSuccess4" :limit="3"
									:auto-upload="false">
									<i slot="default" class="el-icon-plus"></i>
								</el-upload>
							</div>
						</div>
						<div class="append">
							<span class="item1">凭证2:</span>
							<div    >
								<el-upload style="display:flex" :class="{ hide_box4: upload_btn4 }" :disabled="true"
									action="/admin/sys-file/upload" :on-remove="handleRemove4" list-type="picture-card"
									:file-list="formData.businessPhoto" :on-change="handleSuccess4" :limit="3"
									:auto-upload="false">
									<i slot="default" class="el-icon-plus"></i>
								</el-upload>
							</div>
						</div>
						<div class="append">
							<span class="item1">凭证3:</span>
							<div    >
								<el-upload style="display:flex" :class="{ hide_box4: upload_btn4 }" :disabled="true"
									action="/admin/sys-file/upload" :on-remove="handleRemove4" list-type="picture-card"
									:file-list="formData.businessPhoto" :on-change="handleSuccess4" :limit="3"
									:auto-upload="false">
									<i slot="default" class="el-icon-plus"></i>
								</el-upload>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<span slot="footer" class="dialog-footer">
			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="dialogClose" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'

import { fetchTree } from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
export default {
	name: 'saleConfigDialog',
	props: ['visiable', 'multi', 'param'],
	mixins: [selectDialogMixins],
	components: { pager },

	created() {
		this.initSetting();
	},

	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		},
		total(newVal, oldVal) {
			this.$refs.pager.tableDataTotal = newVal
		}
	},

	data() {
		return {
			 upload_btn4: false, // 是否隐藏上传图片按钮
			input: '',
			input2: '',
			input3: '',
			input4: '',
			textarea2: '',
			textarea3: '',
			tenant: {},
			activeName: 'first',
			total: 0,
			filterText: '',
			data: [],
			defaultProps: {
				children: 'children',
				label: 'label',
				id: "id",
				isLeaf: "leaf"
			},
			pageSizes: [10, 20, 100],
			//以上树形
			dataId: 0,
			showEdit: false,
			vxeOption: {},
			isRouterAlive: true,
			// 查询参数
			formData: {
				size: 0,
				current: 1,
				searchCount: false,
				brandName: "",
				itemCode: "",
				itemName: "",
				bigCategoryId: '',
				smallCategoryId: '',
			},
			showDialog: true,
			falseValue: false,
			selectMulti: true,
			searchItemName: '',
			searchItemCode: '',
			searchBrandName: '',
			selectedRow: {
				id: '', name: ''
			}
		};
	},


	methods: {
		          // 上传成功
				  handleSuccess4(res, file, fileList) {
  
  // 上传成功后，隐藏上传按钮
  this.upload_btn = true;
  console.log(res.data.url,"url")
  this.company.picList =[
    {url: res.data.url}
  ]

},
handleRemove4(response, file, fileList) {
  // 删除成功后，显示上传按钮
  // this.company.picList=[]
  this.upload_btn = false;
  // console.log(this.company.picList,"this.company.picList删除后");
},
		flushed() {
			this.$refs['table-m1'].commitProxy('reload');
		},

		cellClickEvent(e) {
			console.log(e.row.id, '单元格点击事件')
		},


		radioChangeEvent({ row }) {
			this.selectedRow = { id: row.id, name: row.itemName }
		},


		// commitRow() {
		// 		this.$emit('commitSelectedRow', this.selectedRow)
		//   this.dialogClose()
		// 	},


		// 分页功能
		changeTablePage(page, flag) {
			this.formData.size = page.pageSize
			this.formData.current = page.currentPage
			this.formData.searchCount = flag
			this.initTableList();
		},

		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},

		// 搜索
		searchEvent() {
			this.formData.itemCode = this.searchItemCode
			this.formData.itemName = this.searchItemName
			this.formData.brandName = this.searchBrandName
			this.$refs.pager.clearStoreTableDataTotal()
			this.formData.current = 1
			this.formData.searchCount = false
			this.$refs.pager.reset()  // 重置分页器
			this.flushed()
		},

		// 重置
		resetEvent() {
			this.searchItemCode = ''
			this.searchItemName = ''
			this.searchBrandName = ''
			this.formData.itemCode = ''
			this.formData.itemName = ''
			this.formData.brandName = ''
			this.formData.current = 1
			this.formData.searchCount = false
			this.formData.bigCategoryId = ''
			this.formData.smallCategoryId = ''
			this.$refs.pager.reset()  // 重置分页器
			this.flushed()
			this.reloadTree()
		},


		// 新增
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},


		reloadTree() {
			this.isRouterAlive = false
			this.$nextTick(function () {
				this.isRouterAlive = true
			})
		},

		// 点击的树形 点
		handleNodeClick(node, data) {
			let id = data.data.id;
			if (data.level === 1) {
				this.formData.bigCategoryId = id;
				this.formData.smallCategoryId = '';
			} else {
				this.formData.smallCategoryId = id;
			}

			this.initTableList();
			this.flushed()
		},

		initTableList() {
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: '/basic/basItem/getListPage',
				param: this.formData,
				method: 'post',
				columns: [
					{ type: "radio", width: 40, title: '', resizable: false, fixed: 'left' },
					{
						title: '品牌名称',
						field: 'brandName',
						width: 110,
						// fixed: 'left'
					},
					{
						title: '产品编码',
						field: 'itemCode',
						width: 110,
					},
					{
						title: '产品名称',
						field: 'itemName',
						width: 110,
					},
					{
						title: '产品型号',
						field: 'itemModel',
						width: 110,
					},
					{
						title: '产品大类',
						field: 'bigCategoryName',
						width: 110,
					},
					{
						title: '产品小类',
						field: 'smallCategoryName',
						width: 110,
					},
					{
						title: '是否结算',
						field: 'isSettle',
						width: 110,
						slots: {
							default: ({ row }) => {
								if (row.isSettle == 0) {
									return [
										<div class="txt-status disable">
											<span>否</span>
										</div>
									];
								} else if (row.isSettle == 1) {
									return [
										<div class="txt-status">
											<span>是</span>
										</div>
									];
								}
							}
						}
					},
					{
						title: '启用状态',
						field: 'usable',
						width: 110,
						slots: {
							default: ({ row }) => {
								if (row.usable == 0) {
									return [
										<div class="txt-status disable">
											<span>禁用</span>
										</div>
									];
								} else if (row.usable == 1) {
									return [
										<div class="txt-status">
											<span>启用</span>
										</div>
									];
								}
							}
						}
					},


					{
						field: 'createTime',
						title: '创建时间',
						width: 110
					},
					{
						title: '创建人',
						field: 'createBy',
						width: 110,

					},

				]
			};
			this.vxeOption = initVxeTable(tableOption);
			this.flushed()
		},


		// 加载页面
		loadChildNode(node, resolve) {
			fetchTree({
				parentId: node.data.id,
				categoryType: 1
			}).then(({ data }) => {
				console.log(data, "data.data的值"),
					resolve(
						data.data.map(item => {
							return {
								label: item.categoryName,
								id: item.id,
								leaf: Number(item.isChild) == 1 ? false : true,
							}
						})
					)
			});
		},

	}
};
</script>
<style lang="scss" scoped>
.append {
	display: flex;
	margin: 10px 0;

	.item1 {
		display: inline-block;
		width: 110px;
		text-align: right;
		line-height: 45px;
		margin-right: 5px;
	}

	.item2 {
		display: inline-block;
		width: 110px;
		text-align: right;
		line-height: 28px;
		margin-right: 5px;
	}
}


#containt .grid-height {
	height: 570px;
}

::v-deep .el-dialog {
	// height: 700px;
	overflow: hidden;
}

::v-deep body .dialog-style {
	border-radius: 8px;
	-webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	// height: 700px;
	overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}





// 重新修改tree组件样式



// .btn_zdy:hover {
//   color: #00c4b3 !important;
//   border: 1px solid #00c4b3 !important;
// }

::v-deep .el-upload--picture-card {
	// margin-top: 10px;
	width: 40px;
	height: 40px;
	line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
	display: inline-block;
	width: 40px;
	height: 40px;
	margin-right: 14px;
	border-radius: 2px;
	padding: 0 !important;
	border-color: #e8e8e8;
	margin-top: 0;
	margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
	width: 40px;
	height: 40px;
	padding: 0 !important;
	position: inherit;
	cursor: pointer;
}
</style>
